import React from 'react';
import DashboardWrapper from '../../components/dashboard/dashboardWrapper/DashboardWrapper';
import UsageRightHeader from '../../components/dashboard/UsageRights/UsageRightHeader';
import CustomSelect from '../../components/common/CustomSelect/CustomSelect';
import FilterLabel from '../../components/dashboard/UsageRights/FilterLabel';
import FilterDropDown from '../../components/dashboard/UsageRights/FilterDropDown';
import styles from '../../styles/usageRights.module.css';
import UsageRightsContent from '../../components/dashboard/UsageRights/UsageRightsContent';
import UsageRightsProvider from '../../components/dashboard/UsageRights/UsageRightsProvider';

export default function UsageRights() {
  return (
    <UsageRightsProvider>
      <DashboardWrapper
        heading="Usage Rights"
        rightHeaderComponent={
          <div className={styles.usageRightsFilterContainer}>
            <CustomSelect
              selectLabel={<FilterLabel />}
              dropDownElement={(setOpened) => <FilterDropDown setOpened={setOpened} />}
            />
          </div>
        }
      >
        <div className={styles.usageRightsWrapper}>
          <UsageRightHeader />
          <UsageRightsContent />
        </div>
      </DashboardWrapper>
    </UsageRightsProvider>
  );
}
